import { render, staticRenderFns } from "./MyRepo.vue?vue&type=template&id=30b11fbd&"
import script from "./MyRepo.vue?vue&type=script&lang=js&"
export * from "./MyRepo.vue?vue&type=script&lang=js&"
import style0 from "./MyRepo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports